import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Button, Stack, Typography, Grid2 } from "@mui/material";
import { PortableText } from "@portabletext/react";
import { navigate } from "gatsby";
import React from "react";
import COLORS from "../../constants/colors";
import StudielanPost from "../../assets/images/studielan-post.png";

interface Slug {
  current: string;
}

interface Color {
  hex: string;
}

interface Campaign {
  publishedAt: string;
  id: string;
  campaignTitle: string;
  campaignTitleDecoration: string;
  _rawCampaignLead: any[];
  slug: Slug;
  activeCampaign: boolean;
  bgColor: Color;
  textColor: Color;
}

const StudentloanCampaign: Campaign = {
  publishedAt: "VI GJØR DET EN GANG TIL!",
  id: "23b22d18-62d6-4631-b047-f1d940387544",
  campaignTitle: "HENT INN STUDIELÅNET I APPEN - VINN 300 000",
  campaignTitleDecoration: "",
  _rawCampaignLead: [
    {
      _type: "block",
      children: [
        {
          _type: "span",
          text: "Horde nedbetalte nylig 300 000 kroner på studielånet til Jenny fra Askøy. I oktober gjør vi en ny trekning!",
        },
      ],
    },
  ],

  slug: { current: "studielan2" },
  activeCampaign: true,
  bgColor: { hex: COLORS.WHITE[100] },
  textColor: { hex: COLORS.WHITE[100] },
};

const StudentloanCampaignShowCaseCard: React.FC = () => {
  const typographyColor = COLORS.BLUE[100];

  const components = {
    block: {
      // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
      normal: ({ children }: any) => (
        <Typography variant="body" color={COLORS.BLACK[100]}>
          {children}
        </Typography>
      ),
    },
  };

  return (
    <Grid2
      bgcolor={COLORS.WHITE[100]}
      borderRadius="20px"
      p={{ xs: "24px", md: "30px" }}
      display="flex"
      flexDirection="column-reverse"
      justifyContent="flex-end"
      alignItems="flex-start"
      gap="48px"
      style={{ position: "relative" }}
    >
      <Stack>
        <Stack
          spacing="24px"
          height={{ xs: "100%", md: "340px" }}
          justifyContent="space-between"
          alignItems="flex-start"
          maxWidth={{ xs: "100%", md: "395px" }}
        >
          <Stack gap="24px">
            <Stack>
              <Typography
                variant="loanInterestExampleDescription"
                color={COLORS.BRIGHT_BLUE[100]}
                sx={{
                  textTransform: "none",
                }}
              >
                {StudentloanCampaign.publishedAt}
              </Typography>
              <Typography
                fontFamily="erlik"
                variant="h2"
                color={typographyColor}
                maxWidth="380px"
              >
                {StudentloanCampaign.campaignTitle}
              </Typography>
            </Stack>

            <PortableText
              value={StudentloanCampaign._rawCampaignLead}
              components={components}
            />
          </Stack>

          <Box alignItems="flex-start" paddingBottom="26px">
            <Button
              onClick={() => {
                navigate(`/gjeldfri/${StudentloanCampaign.slug.current}`);
              }}
              variant="contained"
              // color="dark"
              endIcon={<ArrowForward />}
              sx={{
                border: "2px solid transparent",
                color: COLORS.WHITE[100],
                backgroundColor: COLORS.BLUE[100],
                "&:hover": {
                  border: "2px solid black",
                  color: COLORS.BLACK[100],
                  backgroundColor: COLORS.WHITE[100],
                },
              }}
            >
              Slik blir du med
            </Button>
          </Box>
        </Stack>
      </Stack>

      <Stack>
        <Stack
          component="img"
          src={StudielanPost}
          alt={StudentloanCampaign.campaignTitle}
          sx={{
            width: "100%",
            objectFit: "cover",
            borderRadius: "20px",
          }}
        />
      </Stack>
    </Grid2>
  );
};

export default StudentloanCampaignShowCaseCard;
